import { createSelector } from 'reselect';
import get from 'lodash/get';
import { graphDataOrEmptyObjectSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

const nullableAnnualHomeownersInsuranceSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmptyObject =>
    get(graphDataOrEmptyObject, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.HomeInsurancePerYear`, null),
);

export default nullableAnnualHomeownersInsuranceSelector;
